module.exports = __webpack_public_path__ + "img/icon-infrom.e579426b.png";